(() => {
  // Kompos's Steel variant belongs to the Alloy set tier; its own material stays Steel.
  const setMaterial = variant => variant.id === 47389547331890 ? 'alloy' : variant.title.toLowerCase();
  const matchingVariant = (variants, selected) => variants.find(v => setMaterial(v) === setMaterial(selected)) || (variants.length === 1 ? variants[0] : null);
  const offer = (variant, products) => {
    const sum = products.reduce((total, p) => total + (matchingVariant(p.variants, variant)?.price || 0), 0);
    const original = variant.compare_at_price > variant.price ? variant.compare_at_price : sum;
    return {price:variant.price, original, saving:Math.max(0, original - variant.price)};
  };
  if (typeof module !== 'undefined') module.exports = {matchingVariant, offer};
  if (typeof HTMLElement === 'undefined' || customElements.get('maresi-set-drawer')) return;

  class MaresiSetDrawer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-set-data]').textContent);
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.mss-trigger');
      this.form = this.querySelector('form');
      this.buy = this.querySelector('.mss-buy');
      this.status = this.querySelector('.mss-status');
      this.selected = this.data.variants.find(v => v.id === this.data.selectedId) || this.data.variants[0];
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.data.currency});
      const gallery = document.getElementById('GalleryViewer-' + this.dataset.section);
      if (!gallery || !this.selected) return;
      gallery.append(this.trigger);
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.mss-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
      this.querySelectorAll('[data-set-variant]').forEach(button => button.addEventListener('click', () => {
        this.selected = this.data.variants.find(v => String(v.id) === button.dataset.setVariant);
        this.render();
      }));
      this.form.addEventListener('submit', event => this.add(event));
      this.render();
    }

    open() {
      const info = document.getElementById('ProductInfo-' + this.dataset.section);
      const selectedId = info?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const current = this.dataset.isSet === 'true'
        ? this.data.variants.find(v => String(v.id) === selectedId)
        : this.data.products.find(p => p.id === this.data.productId)?.variants.find(v => String(v.id) === selectedId);
      const material = current || this.data.currentVariant;
      if (this.pageVariantId !== material.id) this.selected = matchingVariant(this.data.variants, material) || this.selected;
      this.pageVariantId = material.id;
      this.render();
      this.dialog.showModal();
      this.dialog.focus({preventScroll:true});
      document.body.classList.add('overflow-hidden');
    }

    render() {
      const selected = this.selected;
      const price = offer(selected, this.data.products);
      this.status.textContent = '';
      this.form.elements.id.value = selected.id;
      this.querySelector('[data-summary-material]').textContent = 'Material selected: ' + selected.title.charAt(0).toUpperCase() + selected.title.slice(1).toLowerCase();
      this.querySelectorAll('[data-set-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.setVariant === String(selected.id))));
      this.querySelectorAll('[data-product-id]').forEach(row => {
        const product = this.data.products.find(p => String(p.id) === row.dataset.productId);
        const variant = matchingVariant(product.variants, selected);
        row.querySelector('[data-item-price]').textContent = variant ? this.format.format(variant.price / 100) : 'Unavailable';
      });
      this.querySelector('[data-set-price]').textContent = this.format.format(price.price / 100);
      this.querySelector('[data-original-price]').textContent = this.format.format(price.original / 100);
      this.querySelector('[data-original-wrap]').hidden = !price.saving;
      this.querySelector('[data-saving]').textContent = this.format.format(price.saving / 100);
      this.querySelector('[data-saving-wrap]').hidden = !price.saving;
      this.buy.disabled = this.busy || !selected.available;
      this.buy.textContent = selected.available ? 'Add full set' : 'Set sold out';
      try { window.bucksCC?.reConvert(); } catch (error) { console.warn('Set drawer currency display unavailable.', error); }
    }

    async add(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || !this.selected.available) return;
      this.busy = true;
      this.buy.disabled = true;
      this.buy.textContent = 'Adding…';
      this.querySelectorAll('[data-set-variant]').forEach(button => { button.disabled = true; });
      this.status.textContent = '';
      this.dialog.setAttribute('aria-busy', 'true');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = {items:[{id:this.selected.id,quantity:1}]};
      if (cart?.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(section => section.id);
        body.sections_url = window.location.pathname;
      }
      let added = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'This set could not be added. Please try again.');
        added = true;
        this.dialog.close();
        if (cart?.renderContents) {
          cart.setActiveElement?.(this.trigger);
          cart.classList.remove('is-empty');
          await cart.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'maresi-set-drawer',productVariantId:String(this.selected.id),cartData:data})?.catch?.(() => {});
        } else window.location.assign(window.routes?.cart_url || root + 'cart');
      } catch (error) {
        if (added) window.location.assign(window.routes?.cart_url || '/cart');
        else this.status.textContent = error.message || 'We could not confirm the add. Please check your bag before trying again.';
      } finally {
        this.busy = false;
        this.dialog.removeAttribute('aria-busy');
        this.buy.disabled = !this.selected.available;
        this.querySelectorAll('[data-set-variant]').forEach(button => { button.disabled = false; });
        this.buy.textContent = this.selected.available ? 'Add full set' : 'Set sold out';
      }
    }
  }
  customElements.define('maresi-set-drawer', MaresiSetDrawer);
})();
